import { APP_ENV, isProduction } from 'src/utils/env';
import { useLayoutEffect } from 'react';
import { useUtmParams } from '../utils/useUtmParams';
import Avo, { AvoEnv, ContextLibraryName, Source } from './Avo';
import GTM from './destinations/gtm';
import Segment from './destinations/segment';
import UAParser from 'ua-parser-js';

const getContextLibraryName = () => {
  const ua = new UAParser();
  if (ua.getDevice().type === 'mobile') {
    switch (ua.getOS().name) {
      case 'iOS':
        return ContextLibraryName.ANALYTICS_WEB_MOBILE_IOS;
      case 'Android':
        return ContextLibraryName.ANALYTICS_WEB_MOBILE_ANDROID;
    }
  }

  return ContextLibraryName.ANALYTICS_WEB_DESKTOP;
};

/**
 * Initializes the analytics library, to be called earlier in the app lifecycle
 * on the client.
 *
 * NOTE: In React 18, the useEffect hook callback will be called twice due to
 * double-rendering. `initAvo` depends on global state which will elide the
 * second render, however reporting the user via identify will happen twice.
 * This behavior is not present in production.
 */
const useAnalytics = () => {
  const utmParams = useUtmParams();

  useLayoutEffect(() => {
    Avo.initAvo(
      {
        env: isProduction() ? AvoEnv.Prod : AvoEnv.Dev,
      },
      {
        acquisitionChannel: undefined,
        contextDeviceType: 'web',
        contextLibraryName: getContextLibraryName(),
        contextLibraryVersion: 'www-1.0.0',
        contextUtmCampaign: utmParams.c || utmParams.utm_campaign,
        contextUtmContent: utmParams.utm_content,
        contextUtmMedium: utmParams.pid || utmParams.utm_medium,
        contextUtmSource: utmParams.af_channel || utmParams.utm_source,
        contextUtmTerm: utmParams.utm_term,
        marketingTitle: undefined,
        offer: utmParams.offer,
        source: Source.WWW,
        tags: `www-${APP_ENV}`,
        campaign: utmParams.utm_campaign,
        channel: utmParams.utm_source,
        mediaSource: utmParams.utm_medium,
        connectionType: navigator?.connection?.type ?? 'unknown',
        isOnline: navigator?.onLine,
      },
      {},
      Segment,
      GTM
    );
  }, [
    utmParams.af_channel,
    utmParams.c,
    utmParams.offer,
    utmParams.pid,
    utmParams.utm_campaign,
    utmParams.utm_content,
    utmParams.utm_medium,
    utmParams.utm_source,
    utmParams.utm_term,
  ]);
};

export default useAnalytics;
